import React from 'react';
import { ConfirmationDialog } from '../../../../shared/ui/dialogs';

export interface QuickFillParameterChangeDialogProps {
  open: boolean;
  oldParameter: string;
  newParameter: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const QuickFillParameterChangeDialog: React.FC<QuickFillParameterChangeDialogProps> = ({
  open,
  oldParameter,
  newParameter,
  onClose,
  onConfirm,
}) => (
  <ConfirmationDialog
    open={open}
    title="Confirm parameter change"
    message={
      <>
        Changing this parameter removes it from every family and adds the new parameter. Existing values will be lost.
        <br /><br />
        <strong>Old parameter:</strong> {oldParameter}<br />
        <strong>New parameter:</strong> {newParameter}<br /><br />
        Do you want to continue?
      </>
    }
    cancelLabel="Cancel"
    confirmLabel="Continue"
    confirmColor="error"
    cancelAriaLabel="Cancel parameter change"
    confirmAriaLabel="Confirm parameter change and continue"
    aria-labelledby="confirm-parameter-change-title"
    onCancel={onClose}
    onConfirm={onConfirm}
  />
);
